import { DecryptData } from "../actions/common";

export const getUserId = () => {
    const data = localStorage.getItem("_id_s");
    const response = DecryptData(data);
    console.log(response,"loged in userId")
    return response;
}